var map = {
	"./AGoodNewsStoryFromPeddie": [
		359,
		57
	],
	"./AGoodNewsStoryFromPeddie.js": [
		359,
		57
	],
	"./AdviceFromTheExpertsPart10": [
		366,
		58
	],
	"./AdviceFromTheExpertsPart10.js": [
		366,
		58
	],
	"./AdviceFromTheExpertsPart11": [
		367,
		59
	],
	"./AdviceFromTheExpertsPart11.js": [
		367,
		59
	],
	"./AdviceFromTheExpertsPart5": [
		281,
		48
	],
	"./AdviceFromTheExpertsPart5.js": [
		281,
		48
	],
	"./AdviceFromTheExpertsPart6": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart6.js": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart7": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart7.js": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart8": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart8.js": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart9": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart9.js": [
		371,
		63
	],
	"./AdviceFromTheExpertsTenantsPart1": [
		282,
		49
	],
	"./AdviceFromTheExpertsTenantsPart1.js": [
		282,
		49
	],
	"./AdviceFromTheExpertsTenantsPart2": [
		283,
		50
	],
	"./AdviceFromTheExpertsTenantsPart2.js": [
		283,
		50
	],
	"./AlternativeEnergyInstallations": [
		360,
		64
	],
	"./AlternativeEnergyInstallations.js": [
		360,
		64
	],
	"./AreGardensOwnedByUnitOwners": [
		284,
		65
	],
	"./AreGardensOwnedByUnitOwners.js": [
		284,
		65
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair": [
		285,
		66
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair.js": [
		285,
		66
	],
	"./CIAGeyserEmergencyAssist": [
		361,
		67
	],
	"./CIAGeyserEmergencyAssist.js": [
		361,
		67
	],
	"./CIAPrivacyPolicy": [
		372,
		13
	],
	"./CIAPrivacyPolicy.js": [
		372,
		13
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers": [
		286,
		68
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers.js": [
		286,
		68
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2": [
		287,
		69
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2.js": [
		287,
		69
	],
	"./CiaIssuesPolicy": [
		288,
		51
	],
	"./CiaIssuesPolicy.js": [
		288,
		51
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining": [
		373,
		70
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining.js": [
		373,
		70
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount": [
		289,
		52
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount.js": [
		289,
		52
	],
	"./CommonPropertyPart1": [
		374,
		71
	],
	"./CommonPropertyPart1.js": [
		374,
		71
	],
	"./CommonPropertyPart2": [
		375,
		72
	],
	"./CommonPropertyPart2.js": [
		375,
		72
	],
	"./CommonPropertyPart3": [
		376,
		73
	],
	"./CommonPropertyPart3.js": [
		376,
		73
	],
	"./CommonPropertyPart4": [
		377,
		74
	],
	"./CommonPropertyPart4.js": [
		377,
		74
	],
	"./CommonPropertyPart5": [
		378,
		75
	],
	"./CommonPropertyPart5.js": [
		378,
		75
	],
	"./CommunitySchemesTraining": [
		379,
		76
	],
	"./CommunitySchemesTraining.js": [
		379,
		76
	],
	"./ComputeCrimeClaimsPart2": [
		290,
		77
	],
	"./ComputeCrimeClaimsPart2.js": [
		290,
		77
	],
	"./ComputeCrimeClaimsPart3": [
		291,
		78
	],
	"./ComputeCrimeClaimsPart3.js": [
		291,
		78
	],
	"./ComputerCrimePolicyWordingChanges": [
		292,
		79
	],
	"./ComputerCrimePolicyWordingChanges.js": [
		292,
		79
	],
	"./ComputerCrimePolicyWordingChanges1": [
		380,
		80
	],
	"./ComputerCrimePolicyWordingChanges1.js": [
		380,
		80
	],
	"./ComputerCrimeWordingProposalFormPart1": [
		293,
		81
	],
	"./ComputerCrimeWordingProposalFormPart1.js": [
		293,
		81
	],
	"./DealingWithABodyCorporateClaim": [
		294,
		82
	],
	"./DealingWithABodyCorporateClaim.js": [
		294,
		82
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection": [
		295,
		83
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection.js": [
		295,
		83
	],
	"./DidYouKnowPart1": [
		381,
		84
	],
	"./DidYouKnowPart1.js": [
		381,
		84
	],
	"./DidYouKnowPart2": [
		296,
		53
	],
	"./DidYouKnowPart2.js": [
		296,
		53
	],
	"./DidYouKnowPart3": [
		297,
		54
	],
	"./DidYouKnowPart3.js": [
		297,
		54
	],
	"./DidYouKnowPart4": [
		382,
		6
	],
	"./DidYouKnowPart4.js": [
		382,
		6
	],
	"./DidYouKnowPart5": [
		383,
		7
	],
	"./DidYouKnowPart5.js": [
		383,
		7
	],
	"./DidYouKnowPart6": [
		384,
		8
	],
	"./DidYouKnowPart6.js": [
		384,
		8
	],
	"./EmployersLiability": [
		298,
		85
	],
	"./EmployersLiability.js": [
		298,
		85
	],
	"./EnforcementOfRulesPart1": [
		385,
		14
	],
	"./EnforcementOfRulesPart1.js": [
		385,
		14
	],
	"./EnforcementOfRulesPart2": [
		386,
		15
	],
	"./EnforcementOfRulesPart2.js": [
		386,
		15
	],
	"./EnforcementOfRulesPart4": [
		387,
		16
	],
	"./EnforcementOfRulesPart4.js": [
		387,
		16
	],
	"./EnforecmentOfRulesPart3": [
		388,
		17
	],
	"./EnforecmentOfRulesPart3.js": [
		388,
		17
	],
	"./EnvironmentalUpgradeForGeysers": [
		299,
		86
	],
	"./EnvironmentalUpgradeForGeysers.js": [
		299,
		86
	],
	"./ExamplesOfCxtraCoverFollowingDamage": [
		300,
		87
	],
	"./ExamplesOfCxtraCoverFollowingDamage.js": [
		300,
		87
	],
	"./FidelityFundCertificatesAndCreditChecks": [
		301,
		88
	],
	"./FidelityFundCertificatesAndCreditChecks.js": [
		301,
		88
	],
	"./FireRiskManagementTipsProtectionAgainstFire": [
		302,
		89
	],
	"./FireRiskManagementTipsProtectionAgainstFire.js": [
		302,
		89
	],
	"./FireWisePart1": [
		389,
		90
	],
	"./FireWisePart1.js": [
		389,
		90
	],
	"./FireWisePart10": [
		390,
		91
	],
	"./FireWisePart10.js": [
		390,
		91
	],
	"./FireWisePart11": [
		391,
		92
	],
	"./FireWisePart11.js": [
		391,
		92
	],
	"./FireWisePart12": [
		362,
		93
	],
	"./FireWisePart12.js": [
		362,
		93
	],
	"./FireWisePart13": [
		303,
		94
	],
	"./FireWisePart13.js": [
		303,
		94
	],
	"./FireWisePart14": [
		304,
		95
	],
	"./FireWisePart14.js": [
		304,
		95
	],
	"./FireWisePart15": [
		305,
		0,
		134
	],
	"./FireWisePart15.js": [
		305,
		0,
		134
	],
	"./FireWisePart16": [
		306,
		96
	],
	"./FireWisePart16.js": [
		306,
		96
	],
	"./FireWisePart17": [
		307,
		97
	],
	"./FireWisePart17.js": [
		307,
		97
	],
	"./FireWisePart18": [
		308,
		98
	],
	"./FireWisePart18.js": [
		308,
		98
	],
	"./FireWisePart19": [
		309,
		99
	],
	"./FireWisePart19.js": [
		309,
		99
	],
	"./FireWisePart2": [
		310,
		0,
		132
	],
	"./FireWisePart2.js": [
		310,
		0,
		132
	],
	"./FireWisePart3": [
		311,
		0,
		133
	],
	"./FireWisePart3.js": [
		311,
		0,
		133
	],
	"./FireWisePart4": [
		363,
		100
	],
	"./FireWisePart4.js": [
		363,
		100
	],
	"./FireWisePart6": [
		392,
		101
	],
	"./FireWisePart6.js": [
		392,
		101
	],
	"./FireWisePart7": [
		393,
		102
	],
	"./FireWisePart7.js": [
		393,
		102
	],
	"./FireWisePart8": [
		394,
		103
	],
	"./FireWisePart8.js": [
		394,
		103
	],
	"./FireWisePart9": [
		395,
		104
	],
	"./FireWisePart9.js": [
		395,
		104
	],
	"./FloodRiskManagementTips": [
		312,
		105
	],
	"./FloodRiskManagementTips.js": [
		312,
		105
	],
	"./GeneralConditionsAndProvisions": [
		313,
		106
	],
	"./GeneralConditionsAndProvisions.js": [
		313,
		106
	],
	"./GeneratorPart2": [
		314,
		2
	],
	"./GeneratorPart2.js": [
		314,
		2
	],
	"./GeneratorPart3": [
		315,
		3
	],
	"./GeneratorPart3.js": [
		315,
		3
	],
	"./GeneratorPart4": [
		396,
		18
	],
	"./GeneratorPart4.js": [
		396,
		18
	],
	"./Generators": [
		397,
		19
	],
	"./Generators.js": [
		397,
		19
	],
	"./GeneratorsAndSolarSystems": [
		398,
		107
	],
	"./GeneratorsAndSolarSystems.js": [
		398,
		107
	],
	"./GuidelinesToProtectingYourVacantProperty": [
		316,
		108
	],
	"./GuidelinesToProtectingYourVacantProperty.js": [
		316,
		108
	],
	"./HeavyRainAndFlooding": [
		399,
		9
	],
	"./HeavyRainAndFlooding.js": [
		399,
		9
	],
	"./KZNFlooding": [
		400,
		20
	],
	"./KZNFlooding.js": [
		400,
		20
	],
	"./KeyInformationDocuments": [
		317,
		109
	],
	"./KeyInformationDocuments.js": [
		317,
		109
	],
	"./LayoutOfCiaWording": [
		318,
		110
	],
	"./LayoutOfCiaWording.js": [
		318,
		110
	],
	"./LegislativeRequirementsForCommunitySchemesPart1": [
		319,
		111
	],
	"./LegislativeRequirementsForCommunitySchemesPart1.js": [
		319,
		111
	],
	"./LegislativeRequirementsForCommunitySchemesPart2": [
		320,
		112
	],
	"./LegislativeRequirementsForCommunitySchemesPart2.js": [
		320,
		112
	],
	"./LetsPlayActivityBook": [
		321,
		113
	],
	"./LetsPlayActivityBook.js": [
		321,
		113
	],
	"./LiabilityClaimsMadeVsLossesOccurring": [
		322,
		114
	],
	"./LiabilityClaimsMadeVsLossesOccurring.js": [
		322,
		114
	],
	"./LithiumBatteryFiresPart2": [
		323,
		115
	],
	"./LithiumBatteryFiresPart2.js": [
		323,
		115
	],
	"./LithiumBetteryFires": [
		364,
		116
	],
	"./LithiumBetteryFires.js": [
		364,
		116
	],
	"./LoavesForMandelaDayUpdate": [
		401,
		117
	],
	"./LoavesForMandelaDayUpdate.js": [
		401,
		117
	],
	"./MachineryBreakdown": [
		324,
		118
	],
	"./MachineryBreakdown.js": [
		324,
		118
	],
	"./MessageFromSasriasManagingDirector": [
		325,
		4
	],
	"./MessageFromSasriasManagingDirector.js": [
		325,
		4
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy": [
		326,
		119
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy.js": [
		326,
		119
	],
	"./NewCpdApprovedTraining": [
		327,
		120
	],
	"./NewCpdApprovedTraining.js": [
		327,
		120
	],
	"./NewsletterSubscriberPOPIACompliance": [
		328,
		21
	],
	"./NewsletterSubscriberPOPIACompliance.js": [
		328,
		21
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers": [
		329,
		121
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers.js": [
		329,
		121
	],
	"./OvercrowdingPart1": [
		402,
		22
	],
	"./OvercrowdingPart1.js": [
		402,
		22
	],
	"./OvercrowdingPart2": [
		403,
		23
	],
	"./OvercrowdingPart2.js": [
		403,
		23
	],
	"./PersonalAccident": [
		330,
		122
	],
	"./PersonalAccident.js": [
		330,
		122
	],
	"./ProtectingVacantPropertyPart1": [
		331,
		123
	],
	"./ProtectingVacantPropertyPart1.js": [
		331,
		123
	],
	"./ProtectingVacantPropertyPart3": [
		332,
		124
	],
	"./ProtectingVacantPropertyPart3.js": [
		332,
		124
	],
	"./ProtectingVacantPropertyPart4": [
		333,
		125
	],
	"./ProtectingVacantPropertyPart4.js": [
		333,
		125
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance": [
		334,
		126
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance.js": [
		334,
		126
	],
	"./RisingDamp": [
		335,
		55
	],
	"./RisingDamp.js": [
		335,
		55
	],
	"./RisingDampPart2": [
		336,
		56
	],
	"./RisingDampPart2.js": [
		336,
		56
	],
	"./SadNewsFromCIA": [
		404,
		24
	],
	"./SadNewsFromCIA.js": [
		404,
		24
	],
	"./SasriaClaims": [
		405,
		25
	],
	"./SasriaClaims.js": [
		405,
		25
	],
	"./SasriaRateIncrease1January2022": [
		337,
		5
	],
	"./SasriaRateIncrease1January2022.js": [
		337,
		5
	],
	"./SasriaRateIncrease2025": [
		406,
		1
	],
	"./SasriaRateIncrease2025.js": [
		406,
		1
	],
	"./The10YearPlanPart1": [
		407,
		26
	],
	"./The10YearPlanPart1.js": [
		407,
		26
	],
	"./The10YearPlanPart2": [
		338,
		27
	],
	"./The10YearPlanPart2.js": [
		338,
		27
	],
	"./The10YearPlanPart3": [
		365,
		28
	],
	"./The10YearPlanPart3.js": [
		365,
		28
	],
	"./The10YearPlanPart4": [
		408,
		29
	],
	"./The10YearPlanPart4.js": [
		408,
		29
	],
	"./TheDevastationOfLithium": [
		358,
		127
	],
	"./TheDevastationOfLithium.js": [
		358,
		127
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies": [
		339,
		128
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies.js": [
		339,
		128
	],
	"./TheftAndCrimeRiskManagement": [
		340,
		129
	],
	"./TheftAndCrimeRiskManagement.js": [
		340,
		129
	],
	"./TrusteesIndemnity": [
		341,
		30
	],
	"./TrusteesIndemnity.js": [
		341,
		30
	],
	"./UnderstandingLiabilityClaimsPart1": [
		409,
		10
	],
	"./UnderstandingLiabilityClaimsPart1.js": [
		409,
		10
	],
	"./UnderstandingLiabilityClaimsPart2": [
		410,
		130
	],
	"./UnderstandingLiabilityClaimsPart2.js": [
		410,
		130
	],
	"./UnderstandingLiabilityClaimsPart3": [
		411,
		11
	],
	"./UnderstandingLiabilityClaimsPart3.js": [
		411,
		11
	],
	"./UnderstandingLiabilityClaimsPart4": [
		412,
		12
	],
	"./UnderstandingLiabilityClaimsPart4.js": [
		412,
		12
	],
	"./ValidityOfClaims": [
		342,
		31
	],
	"./ValidityOfClaims.js": [
		342,
		31
	],
	"./ValidityOfClaimsPart2": [
		343,
		32
	],
	"./ValidityOfClaimsPart2.js": [
		343,
		32
	],
	"./WaterLeakageTips": [
		344,
		33
	],
	"./WaterLeakageTips.js": [
		344,
		33
	],
	"./WaterproofingAndWaterIngressPart1": [
		413,
		34
	],
	"./WaterproofingAndWaterIngressPart1.js": [
		413,
		34
	],
	"./WaterproofingAndWaterIngressPart2": [
		414,
		35
	],
	"./WaterproofingAndWaterIngressPart2.js": [
		414,
		35
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy": [
		345,
		36
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy.js": [
		345,
		36
	],
	"./WhatAreGeysersCoveredFor": [
		346,
		37
	],
	"./WhatAreGeysersCoveredFor.js": [
		346,
		37
	],
	"./WhatConstitutesAVoluntaryWorker": [
		347,
		38
	],
	"./WhatConstitutesAVoluntaryWorker.js": [
		347,
		38
	],
	"./WhatDamageRiskManagement": [
		348,
		39
	],
	"./WhatDamageRiskManagement.js": [
		348,
		39
	],
	"./WhatIsASpecificExclusion": [
		349,
		40
	],
	"./WhatIsASpecificExclusion.js": [
		349,
		40
	],
	"./WhatIsCoveredUnderExtraCover": [
		350,
		41
	],
	"./WhatIsCoveredUnderExtraCover.js": [
		350,
		41
	],
	"./WhatIsCoveredUnderTheLiabilitySection": [
		351,
		42
	],
	"./WhatIsCoveredUnderTheLiabilitySection.js": [
		351,
		42
	],
	"./WhatIsExtraCoverFollowingDamage": [
		352,
		43
	],
	"./WhatIsExtraCoverFollowingDamage.js": [
		352,
		43
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover": [
		353,
		44
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover.js": [
		353,
		44
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys": [
		354,
		45
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys.js": [
		354,
		45
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery": [
		355,
		46
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery.js": [
		355,
		46
	],
	"./WhenIsALossadjusterAppointed": [
		356,
		47
	],
	"./WhenIsALossadjusterAppointed.js": [
		356,
		47
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires": [
		357,
		131
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires.js": [
		357,
		131
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 256;
module.exports = webpackAsyncContext;